import { Navigate, Outlet, useLoaderData, useMatchRoute } from '@tanstack/react-router';
import { useEffect } from 'react';
import { useUserRoles } from '@anytag/auth';
import { EngagementCampaignStatus } from '@anytag/graphql';
import { RenderDataWithFallback } from '@anytag/shared-atoms';
import { useQueryHelper } from '@anytag/shared-hooks';
import { Header } from '@anytag/shared-molecules';
import { EngagementStatus, EngagementTabs, stickyInfluencersSearchHeader } from '@anytag/shared-organisms';
import { EngagementRouter } from '../../../app/_private-routes/engagement';
import { EngagementDetailsProvider } from './engagement-details-context';

export const EngagementDetails = () => {
  const { isAdvertiser } = useUserRoles();
  const matchPath = useMatchRoute();
  const { t, enqueueSnackbar, navigate } = useQueryHelper();
  const { loading, networkStatus, engagement, engagementProposal, errorMessage } = useLoaderData({
    from: '/_private-routes/engagement/$id'
  }) as Awaited<ReturnType<(typeof EngagementRouter)['/_private-routes/engagement/$id']['1']['loader']>>;

  useEffect(() => {
    if (errorMessage) {
      enqueueSnackbar(t(errorMessage), { variant: 'error' });
      navigate({ to: '/engagement' });
    }
  }, [errorMessage]);

  if (
    isAdvertiser &&
    matchPath({ to: '/engagement/$id/proposal' }) &&
    engagement?.status === EngagementCampaignStatus.DRAFT
  ) {
    return <Navigate to="/not-found" />;
  }

  return (
    <RenderDataWithFallback loading={loading && networkStatus === 1}>
      {!!engagement && !!engagementProposal ? (
        <EngagementDetailsProvider value={{ engagement, engagementProposal }}>
          <div>
            <div className={stickyInfluencersSearchHeader}>
              <Header>
                <EngagementStatus status={engagement?.status} className="ml-1" />
              </Header>
              <EngagementTabs engagement={engagement} />
            </div>
            <Outlet />
          </div>
        </EngagementDetailsProvider>
      ) : null}
    </RenderDataWithFallback>
  );
};
